// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 854 ? "pdfjs" : chunkId) + "." + {"453":"ddb05bc9","854":"ca593579"}[chunkId] + ".chunk.js";
};